import ContactForm from "../forms/contactForm";

function Cta() {
  return (
    <>
      <section className="px-6 lg:px-24 flex flex-col lg:flex-row gap-6">
        <div className="flex flex-col items-center justify-center w-full">
          <img
            src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/cta-img-1.png"
            alt="Drzewus - skontaktuj się z nami"
          />
        </div>
        <div className="flex flex-col items-center justify-center lg:w-1/2 w-full">
          <ContactForm />
        </div>
      </section>
    </>
  );
}

export default Cta;
